// Full Calendar Plugins
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import interactionPlugin from '@fullcalendar/interaction'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

/* eslint-disable */
import { ref, computed, watch, onMounted } from '@vue/composition-api'
import store from '@/store'

import ptLocale from "@fullcalendar/core/locales/pt-br";
import AppConstants from '@/appConstants'
import { Popover } from "bootstrap";
import {auto, createPopper} from '@popperjs/core'
import { formatDate, formatDateToMonthShort } from '@/@core/utils/filter'
import convertDatetimeHelper from '@/helpers/convert-datetime-helper'

export default function userCalendar() {
  // ------------------------------------------------
  // DISCLOSURE TYPE
  // ------------------------------------------------
  store.commit('calendar/SET_DISCLOSURE_TYPE', AppConstants.EVENT_SCHEDULE_DISCLOSURE_TYPE);
  store.commit('calendar/SET_SELECTED_DISCLOSURE_TYPE', AppConstants.EVENT_SCHEDULE_DISCLOSURE_TYPE.map(item => item.id));

  store.commit('calendar/SET_NEWS_TYPE', AppConstants.NEWS_TYPE_LIST);
  store.commit('calendar/SET_SELECTED_NEWS_TYPE', AppConstants.NEWS_TYPE_LIST.map(item => item.id));
  // ------------------------------------------------
  // ORIGINS
  // ------------------------------------------------
  const loadOrigins = () => {
    store.dispatch('calendar/getOrigins', { params: new URLSearchParams() }).then((data) => {
      store.commit('calendar/SET_ORIGINS', data);
      // store.commit('calendar/SET_SELECTED_ORIGINS', data.map(item => item.id));
    })
  }
  loadOrigins();

  // ------------------------------------------------
  // REGIONS
  // ------------------------------------------------
  // const loadRegions = () => {
  //   const list = [
  //     {
  //       id: 0, name: 'Todos', locale: {
  //         locale: 'all',
  //         name: 'Todos',
  //       }
  //     },
  //     {
  //       id: 1, name: 'Brasil', locale: {
  //         locale: 'br',
  //         img: require('@/assets/images/flags/br.png'),
  //         name: 'Portuguese',
  //       }
  //     },
  //     {
  //       id: 2, name: 'Estados Unidos', locale: {
  //         locale: 'en',
  //         img: require('@/assets/images/flags/en.png'),
  //       }
  //     },
  //     {
  //       id: 3, name: 'Europa', locale: {
  //         locale: 'europe',
  //         img: require('@/assets/images/flags/europe.png'),
  //       }
  //     },
  //     {
  //       id: 4, name: 'China', locale: {
  //         locale: 'ch',
  //         img: require('@/assets/images/flags/ch.png'),
  //       }
  //     }
  //   ];

  //   store.commit('calendar/SET_REGIONS', list);
  //   store.commit('calendar/SET_SELECTED_REGION', list[0].id);
  // }
  // loadRegions();

  // Use toast
  const toast = useToast()
  // ------------------------------------------------
  // refCalendar
  // ------------------------------------------------
  const refCalendar = ref(null)

  // ------------------------------------------------
  // calendarApi
  // ------------------------------------------------
  let calendarApi = null
  onMounted(() => {
    calendarApi = refCalendar.value.getApi()
  })

  // ------------------------------------------------
  // calendars
  // ------------------------------------------------
  const calendarsColor = {
    Business: 'primary',
    Holiday: 'success',
    Personal: 'danger',
    Family: 'warning',
    ETC: 'info',
  }

  // ------------------------------------------------
  // event
  // ------------------------------------------------
  const blankEvent = {
    title: '',
    start: '',
    end: '',
    allDay: false,
    url: '',
    type: 'news',
    origin: {},
    region: {},
    newsData: {},
    extendedProps: {
      location: '',
      description: '',
    },
  }
  const event = ref(JSON.parse(JSON.stringify(blankEvent)))
  const clearEventData = () => {
    event.value = JSON.parse(JSON.stringify(blankEvent))
  }
  const currentNewsDetail = ref({});
  const clearCurrentNewsDetail = () => {
    currentNewsDetail.value = {};
  }

  // *===========================================================================---*
  // *--------- Calendar API Function/Utils --------------------------------------------*
  // Template Future Update: We might move this utils function in its own file
  // *===========================================================================---*

  // ------------------------------------------------
  // (UI) addEventInCalendar
  // ? This is useless because this just add event in calendar and not in our data
  // * If we try to call it on new event then callback & try to toggle from calendar we get two events => One from UI and one from data
  // ------------------------------------------------
  // const addEventInCalendar = eventData => {
  //   toast({
  //     component: ToastificationContent,
  //     position: 'bottom-right',
  //     props: {
  //       title: 'Event Added',
  //       icon: 'CheckIcon',
  //       variant: 'success',
  //     },
  //   })
  //   calendarApi.addEvent(eventData)
  // }

  // ------------------------------------------------
  // (UI) updateEventInCalendar
  // ------------------------------------------------
  const updateEventInCalendar = (updatedEventData, propsToUpdate, extendedPropsToUpdate) => {
    toast({
      component: ToastificationContent,
      props: {
        title: 'Event Updated',
        icon: 'CheckIcon',
        variant: 'success',
      },
    })

    const existingEvent = calendarApi.getEventById(updatedEventData.id)

    // --- Set event properties except date related ----- //
    // ? Docs: https://fullcalendar.io/docs/Event-setProp
    // dateRelatedProps => ['start', 'end', 'allDay']
    /* eslint-disable */
    for (let index = 0; index < propsToUpdate.length; index++) {
      const propName = propsToUpdate[index]
      existingEvent.setProp(propName, updatedEventData[propName])
    }

    // --- Set date related props ----- //
    // ? Docs: https://fullcalendar.io/docs/Event-setDates
    existingEvent.setDates(updatedEventData.start, updatedEventData.end, { allDay: updatedEventData.allDay })

    // --- Set event's extendedProps ----- //
    // ? Docs: https://fullcalendar.io/docs/Event-setExtendedProp
    /* eslint-disable */
    for (let index = 0; index < extendedPropsToUpdate.length; index++) {
      const propName = extendedPropsToUpdate[index]
      existingEvent.setExtendedProp(propName, updatedEventData.extendedProps[propName])
    }
  }

  // ------------------------------------------------
  // (UI) removeEventInCalendar
  // ------------------------------------------------
  const removeEventInCalendar = eventId => {
    toast({
      component: ToastificationContent,
      position: 'bottom-right',
      props: {
        title: 'Event Removed',
        icon: 'TrashIcon',
        variant: 'danger',
      },
    })
    calendarApi.getEventById(eventId).remove()
  }

  // ------------------------------------------------
  // grabEventDataFromEventApi
  // ? It will return just event data from fullCalendar's EventApi which is not required for event mutations and other tasks
  // ! You need to update below function as per your extendedProps
  // ------------------------------------------------
  const grabEventDataFromEventApi = (eventApi) => {
    // console.log('[grabEventDataFromEventApi]',eventApi);
    const {
      id,
      title,
      start,
      end,
      origin,
      type,
      region,
      /* eslint-disable */
      extendedProps,
      allDay,
      newsData
    } = eventApi

    return {
      id,
      title,
      start,
      end,
      type,
      region,
      origin,
      extendedProps,
      allDay,
      newsData,
    }
  }

  // ------------------------------------------------
  // addEvent
  // ------------------------------------------------
  const addEvent = eventData => {
    if (eventData.start) {
      eventData.start = new Date(eventData.start).getTime();
    }
    if (eventData.end) {
      eventData.end = new Date(eventData.end).getTime();
    }
    store.dispatch('calendar/addEvent', { form: eventData, params: new URLSearchParams() }).then(() => {
      /* eslint-disable */
      toast({
        component: ToastificationContent,
        props: {
          title: 'Event Added',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
      refetchEvents()

    })
  }

  // ------------------------------------------------
  // updateEvent
  // ------------------------------------------------
  const updateEvent = eventData => {
    if (eventData.start) {
      eventData.start = new Date(eventData.start).getTime();
    }
    if (eventData.end) {
      eventData.end = new Date(eventData.end).getTime();
    }
    store.dispatch('calendar/updateEvent', { form: eventData, params: new URLSearchParams() }).then(response => {
      const updatedEvent = response;

      const propsToUpdate = ['id', 'title', 'url']
      const extendedPropsToUpdate = ['location', 'description']

      updateEventInCalendar(updatedEvent, propsToUpdate, extendedPropsToUpdate)
    })
  }

  // ------------------------------------------------
  // removeEvent
  // ------------------------------------------------
  const removeEvent = () => {
    const eventId = event.value.id
    store.dispatch('calendar/removeEvent', { id: eventId }).then(() => {
      removeEventInCalendar(eventId)
    })
  }

  const importEvents = (form) => {
    const params = new URLSearchParams();
    store
      .dispatch('calendar/importEvents', {
        form: form,
        params: params
      })
      .then(response => {
        console.log(response);
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error import calendar events',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // ------------------------------------------------
  // refetchEvents
  // ------------------------------------------------
  const refetchEvents = () => {
    calendarApi.refetchEvents()
  }

  // ------------------------------------------------
  // selectedNewsType
  // ------------------------------------------------
  const selectedNewsType = computed(() => store.state.calendar.selectedNewsType)
  watch(selectedNewsType, () => {
    refetchEvents()
  })
  // ------------------------------------------------
  // selectedDisclosureType
  // ------------------------------------------------
  const selectedDisclosureType = computed(() => store.state.calendar.selectedDisclosureType)
  watch(selectedDisclosureType, () => {
    refetchEvents()
  })
  // // ------------------------------------------------
  // // selectedOrigins
  // // ------------------------------------------------
  const selectedOrigins = computed(() => store.state.calendar.selectedOrigins)

  watch(selectedOrigins, () => {
    refetchEvents()
  })
  
  // // ------------------------------------------------
  // // selectedRegion
  // // ------------------------------------------------
  // const selectedRegion = computed(() => store.state.calendar.selectedRegion)

  // watch(selectedRegion, () => {
  //   refetchEvents()
  // })

  // --------------------------------------------------------------------------------------------------
  // AXIOS: fetchEvents
  // * This will be called by fullCalendar to fetch events. Also this can be used to refetch events.
  // --------------------------------------------------------------------------------------------------
  const openSendNews = () => {
    isEventHandlerSidebarActiveSendNews.value = true;
  }

  const displayOverlay = ref(false);

  const stateFilter = computed(() => store.state.manageNews.filter);
  const currentEventStatus = computed(() => store.state.manageNews.currentEventStatus);

  watch(currentEventStatus, () => {
    refetchEvents()
  })
  
  const searchParams = (startStr, endStr) => {
    const params = new URLSearchParams();
    params.append("page", 1);
    params.append("limit", 30);
    // params.append("type", AppConstants.NEWS_TYPE_ENUM.EVENT);
    params.append("layout", AppConstants.NEWS_LAYOUT.EVENT);
    params.append("calendar", true);

    params.append("dt_range", `${convertDatetimeHelper.convertDateParams(startStr)} até ${convertDatetimeHelper.convertDateParams(endStr)}`);

    if (stateFilter.value.newsId) {
      params.append("id", stateFilter.value.newsId);
    }
    if (stateFilter.value.origin) {
      params.append("source", stateFilter.value.origin.id);
    }
    if (currentEventStatus.value && currentEventStatus.value.id) {
      params.append("event_status", currentEventStatus.value.id);
    } else {
      params.append("event_status", AppConstants.EVENT_STATUS.PUBLISHED);
    }
    if (stateFilter.value.subject) {
      params.append("subject", stateFilter.value.subject.id);
    }
    if (stateFilter.value.user) {
      params.append("user", stateFilter.value.user.id);
    }
    if (stateFilter.value.dt_report) {
      params.append("dt_report", stateFilter.value.dt_report);
    }
    if (stateFilter.value.dt_create) {
      params.append("dt_create", stateFilter.value.dt_create);
    }
    if (stateFilter.value.dt_end) {
      params.append("dt_end", stateFilter.value.dt_end);
    }
    if (stateFilter.value.important) {
      params.append("importance", stateFilter.value.important);
    }
    if (stateFilter.value.inLive) {
      params.append("inLive", stateFilter.value.inLive);
    }
    if (stateFilter.value.flashes) {
      params.append("flashes", stateFilter.value.flashes);
    }
    if (stateFilter.value.highlight) {
      params.append("highlight", stateFilter.value.highlight);
    }
    if (stateFilter.value.exclusive) {
      params.append("exclusive", stateFilter.value.exclusive);
    }
    if (stateFilter.value.mostReadDay) {
      params.append("mostReadDay", stateFilter.value.mostReadDay);
    }
    if (stateFilter.value.mostReadWeek) {
      params.append("mostReadWeek", stateFilter.value.mostReadWeek);
    }
    if (stateFilter.value.mostReadMonth) {
      params.append("mostReadMonth", stateFilter.value.mostReadMonth);
    }
    if (stateFilter.value.active) {
      if (stateFilter.value.active == AppConstants.ACTIVE.TRUE) {
        params.append("active", true);
      }else if (stateFilter.value.active == AppConstants.ACTIVE.FALSE) {
        params.append("active", false);
      }
    }
    if (stateFilter.value.layout !== undefined) {
      params.append("layout", stateFilter.value.layout);
    }

    if (stateFilter.value.searchQuery) {
      params.append("searchQuery", stateFilter.value.searchQuery);
    }

    params.append(AppConstants.PARAMS_USER_FILTER, true);

    return params;
  };

  const fetchEvents = (info, successCallback) => {
    // If there's no info => Don't make useless API call
    if (!info) return
    // console.log('calendar info: ', info);
    displayOverlay.value = true;

    const params = searchParams(info.startStr, info.endStr);
    
    // Fetch Events from API endpoint
    store
      .dispatch('calendar/fetchNews', {
        params: params
      })
      .then(response => {
        const dataResp = response.data.map(item => {
          return {
            title: item.content.title.data,
            end: item.eventScheduleDuration_dateTo,
            start: item.eventScheduleDuration_dateFrom,
            allDay: false,
            url: '',
            type: item.type,
            origin: {},
            region: {},
            extendedProps: {
              location: '',
              description: '',
            },
            newsData: item
          }
        });
        displayOverlay.value = false;
        successCallback(dataResp)
      })
      .catch((err) => {
        console.log(err);
        displayOverlay.value = false;
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching calendar events',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }



  // ------------------------------------------------------------------------
  // calendarOptions
  // * This isn't considered in UI because this is the core of calendar app
  // ------------------------------------------------------------------------
  const calendarOptions = ref({
    plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin, listPlugin],
    initialView: 'dayGridMonth',
    locale: ptLocale,
    headerToolbar: {
      start: 'sidebarToggle, prev, next, title',
      end: 'dayGridMonth,timeGridWeek,timeGridDay,list',
    },
    events: fetchEvents,

    // text buttons
    buttonText: {
      // prev: 'Anterior',
      // next: 'Próximo',
      // prevYear: 'Ano anterior',
      // nextYear: 'Próximo ano',
      today: 'Hoje',
      month: 'Mês',
      week: 'Semana',
      day: 'Dia',
      list: 'Lista'
    },

    /*
      Enable dragging and resizing event
      ? Docs: https://fullcalendar.io/docs/editable
    */
    editable: false,

    /*
      Enable resizing event from start
      ? Docs: https://fullcalendar.io/docs/eventResizableFromStart
    */
    eventResizableFromStart: true,

    /*
      Automatically scroll the scroll-containers during event drag-and-drop and date selecting
      ? Docs: https://fullcalendar.io/docs/dragScroll
    */
    dragScroll: false,

    /*
      Max number of events within a given day
      ? Docs: https://fullcalendar.io/docs/dayMaxEvents
    */
    dayMaxEvents: 4,

    /*
      Determines if day names and week names are clickable
      ? Docs: https://fullcalendar.io/docs/navLinks
    */
    navLinks: true,

    eventClassNames({ event: calendarEvent }) {
      /* eslint-disable */
      const newsType = AppConstants.NEWS_TYPE_LIST.find(item => item.id == calendarEvent._def.extendedProps.type);
      if (!newsType) return [];
      if (newsType.id == AppConstants.NEWS_TYPE_ENUM.CALENDAR) {
        const disclosureType = AppConstants.EVENT_SCHEDULE_DISCLOSURE_TYPE.find(item => item.id == calendarEvent._def.extendedProps.newsData.disclosureType);
        return [disclosureType ? disclosureType.color : ''];
      }
      return [newsType.color];
      // const colorName = calendarsColor[calendarEvent._def.extendedProps.calendar]

      // return [
      //   // Background Color
      //   `bg-light-${colorName}`,
      // ]
    },
    eventClick({ event: clickedEvent }) {
      // * Only grab required field otherwise it goes in infinity loop
      // ! Always grab all fields rendered by form (even if it get `undefined`) otherwise due to Vue3/Composition API you might get: "object is not extensible"
      // console.log('[eventClick]',clickedEvent)
      event.value = grabEventDataFromEventApi(clickedEvent._def.extendedProps.newsData)
      event.value = grabEventDataFromEventApi(clickedEvent._def)
      currentNewsDetail.value = JSON.parse(JSON.stringify(clickedEvent._def.extendedProps.newsData));

      /* eslint-disable */
      isEventHandlerSidebarActive.value = true
      isEventHandlerSidebarImport.value = false
    },

    customButtons: {
      sidebarToggle: {
        // --- This dummy text actual icon rendering is handled using SCSS ----- //
        text: 'sidebar',
        click() {
          /* eslint-disable */
          isCalendarOverlaySidebarActive.value = !isCalendarOverlaySidebarActive.value
        },
      },
    },

    dateClick(info) {
      /*
        ! Vue3 Change
        Using Vue.set isn't working for now so we will try to check reactivity in Vue 3 as it can handle this automatically
        ```
        event.value.start = info.date
        ```
      */
      // openSendNews();
      // event.value = JSON.parse(JSON.stringify(Object.assign(event.value, { start: info.date })))
      // /* eslint-disable */
      // isEventHandlerSidebarActive.value = true
      // isEventHandlerSidebarImport.value = false
    },

    /*
      Handle event drop (Also include dragged event)
      ? Docs: https://fullcalendar.io/docs/eventDrop
      ? We can use `eventDragStop` but it doesn't return updated event so we have to use `eventDrop` which returns updated event
    */
    eventDrop({ event: droppedEvent }) {
      updateEvent(grabEventDataFromEventApi(droppedEvent))
    },

    /*
      Handle event resize
      ? Docs: https://fullcalendar.io/docs/eventResize
    */
    eventResize({ event: resizedEvent }) {
      updateEvent(grabEventDataFromEventApi(resizedEvent))
    },
    eventMouseEnter({ event: data }) {
      const newsData = JSON.parse(JSON.stringify(data._def.extendedProps.newsData))
      // console.log('[eventMouseEnter][event]', data);
      // console.log('[eventMouseEnter][newsData]', newsData);
    },
    eventDidMount(info) {
      // info.el
      const newsData = info.event._def.extendedProps.newsData;
      // console.log('[calendar][eventDidMount]', info.el);
      // return createPopper(info.el, `<h2>${newsData.hat[0] ? newsData.hat[0].name.toUpperCase() : ''}</h2>
      // <p><b>${newsData.content.title.data}</b></p>
      // <p><small>${newsData.content.abstract.data}</small></p>
      // <br/>
      // <hr>
      // <p>${newsData.content.body.data}</p>
      // `, {
      //   placement: 'bottom',
      // })

      // return new Popper(info.el, '', {
      //   placement: 'auto',
      //   modifiers: {
      //     preventOverflow: { enabled: false },
      //   },
      // });
      return new Popover(info.el, {
        // title: newsData.content.title.data,
        placement: "auto",
        trigger: "hover",
        customClass: "popoverStyle",
        content: `
        <h2>${newsData.hat[0] ? newsData.hat[0].name.toUpperCase() : ''}</h2>
        <p><b>${newsData.content.title.data}</b></p>
        <p><small>${newsData.content.abstract.data}</small></p>
        <br/>
        <hr>
        <p>${newsData.content.body.data ? newsData.content.body.data.substring(0,100) : ''}</p>
        `,
        html: true,
        delay: { "show": 500, "hide": 500 },
        boundary: 'clippingParents',
        // popperConfig: {strategy: 'fixed', placement: 'auto'},
        // container: true,
        // selector: true,
        // sanitize: false,
        // animation: false,
        
      });
    },

    // Get direction from app state (store)
    direction: computed(() => (store.state.appConfig.isRTL ? 'rtl' : 'ltr')),
    rerenderDelay: 350,
    eventTimeFormat: { 
      hour: '2-digit',
      minute: '2-digit',
      meridiem: false,
    },

    nextDayThreshold: '00:00:00'
  })

  // ------------------------------------------------------------------------

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const isEventHandlerSidebarActive = ref(false)
  const isEventHandlerSidebarActiveSendNews = ref(false)
  const isEventHandlerSidebarImport = ref(false)

  const isCalendarOverlaySidebarActive = ref(false)

  return {
    refCalendar,
    isCalendarOverlaySidebarActive,
    calendarOptions,
    event,
    currentNewsDetail,
    displayOverlay,
    clearEventData,
    addEvent,
    updateEvent,
    removeEvent,
    refetchEvents,
    fetchEvents,
    importEvents,
    openSendNews,
    // ----- UI ----- //
    isEventHandlerSidebarActive,
    isEventHandlerSidebarActiveSendNews,
    isEventHandlerSidebarImport,

  }
}
